import { render, staticRenderFns } from "./menuLateral.vue?vue&type=template&id=45702803"
import script from "./menuLateral.vue?vue&type=script&lang=js"
export * from "./menuLateral.vue?vue&type=script&lang=js"
import style0 from "./menuLateral.vue?vue&type=style&index=0&id=45702803&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports